/* eslint-disable no-unused-vars, no-useless-constructor*/
import React from 'react';
import PropTypes from 'prop-types';
import ReactCompareImage from 'react-compare-image';
import classNames from 'classnames';

import BaseComponent from "../../../panther/components/base/BaseComponent";

class ComparatorContainer extends BaseComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let maxWidth = this.props.maxWidth ? (this.props.maxWidth + 'px') : 'none';
        let classes = classNames("ptr-comparators-container", {
        });

        let legendClasses = this.props.legend ? classNames("ptr-comparator-legend", this.props.legend.position) : null;

        return (
            <div style={{maxWidth: maxWidth}} className={classes}>
                <div className="ptr-comparator-captions">
                    {this.props.leftCaption ? (<div>{this.props.leftCaption}</div>) : null}
                    {this.props.rightCaption ? (<div>{this.props.rightCaption}</div>) : null}
                </div>
                <ReactCompareImage sliderLineColor={this.props.sliderLineColor} vertical={this.props.vertical} leftImage={this.props.leftImageSrc} rightImage={this.props.rightImageSrc} />

                {this.props.legend ? (<img className={legendClasses} src={this.props.legend.source}/>) : null}
                {this.props.bottomLabel ? (<span className="ptr-comparator-label centered">{this.props.bottomLabel}</span>) : null}
            </div>
        );
    }
}

ComparatorContainer.propTypes = {
    bottomLabel: PropTypes.string,
    light: PropTypes.bool,
    maxWidth: PropTypes.number,
    leftImageSrc: PropTypes.string,
    leftCaption: PropTypes.string,
    rightImageSrc: PropTypes.string,
    rightCaption: PropTypes.string,
    sliderLineColor: PropTypes.string,
    vertical: PropTypes.bool
};

export default ComparatorContainer;